module.exports = __webpack_public_path__ + "img/Solutions-EduAssist.7a0db4a0.jpg";